"use client";
import { Input } from "cy-fe/src/components/Forms/Input";
import { Button, Label } from "cy-fe";
import { Link } from "../components/Link";
import { PhoneNumberInput } from "cy-ui/components/PhoneNumber";
import { ErrorBanner } from "../components/ErrorBanner";
import { TabButton, Tab } from "../components/tabs";
import { useSignInForm } from "./hooks/useSignInForm";

export enum TabType {
  UserId = "UserId",
  Phone = "phone",
}

export interface SignInFormProps {
  emailLoginDisabled?: boolean;
  defaultPhoneIsd?: string;
  allowedCountryCodes?: string[];
}

export function SignInForm({
  emailLoginDisabled,
  defaultPhoneIsd = "27",
  allowedCountryCodes,
}: SignInFormProps) {
  const {
    submitting,
    selectedTab,
    userId,
    password,
    mobile,
    error,
    setSelectedTab,
    setUserId,
    setPassword,
    onSubmit,
    mobileChangeHandler,
  } = useSignInForm(defaultPhoneIsd, {
    localStorage:
      typeof window !== "undefined" ? window.localStorage : undefined,
  });

  return (
    <form
      id={`${selectedTab}-login-form`}
      onSubmit={onSubmit}
      className="text-default mx-auto w-[90dvw] max-w-[90dvw] space-y-6 px-2 sm:max-w-lg"
      data-testid="signin-form"
    >
      <Tab className="" selectedTab={selectedTab} onChange={setSelectedTab}>
        <TabButton
          selected={selectedTab === TabType.Phone}
          onchange={setSelectedTab}
          value={TabType.Phone}
        >
          Mobile
        </TabButton>
        <TabButton
          selected={selectedTab === TabType.UserId}
          onchange={setSelectedTab}
          value={TabType.UserId}
        >
          User Id
        </TabButton>
      </Tab>
      {error ? <ErrorBanner error={error} /> : null}
      <div>
        {selectedTab === TabType.UserId ? (
          <>
            <Label className="text-sm font-light" htmlFor="email">
              Your&nbsp;
              {emailLoginDisabled ? null : "email / "}
              customer id
            </Label>
            <Input
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              vSize="lg"
              id="email"
              autoComplete={emailLoginDisabled ? "customer_id" : "email"}
              name="email"
              placeholder=""
              type={emailLoginDisabled ? undefined : "email"}
              data-testid="userid-input"
            />
          </>
        ) : (
          <>
            <Label
              htmlFor={"phone-number-input"}
              className="text-sm font-light"
            >
              Your mobile number
            </Label>
            <PhoneNumberInput
              inputId={"phone-number-input"}
              value={{
                isd: mobile.isd || "",
                number: mobile.number || "",
              }}
              onChange={mobileChangeHandler}
              allowedCountryCodes={allowedCountryCodes}
              data-testid="phone-input"
            />
          </>
        )}
      </div>
      <div>
        <Label htmlFor={"input-password-for-credentials-provider"}>
          Your password
        </Label>
        <Input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          vSize="lg"
          id="input-password-for-credentials-provider"
          name="password"
          placeholder=""
          required
          type="password"
          data-testid="password-input"
        />
      </div>
      <div>
        <Button
          loading={submitting}
          type="submit"
          vSize="lg"
          className="w-full"
          data-testid="submit-button"
        >
          Log in
        </Button>
        <Link className="mt-4 ml-2 block" href="/public/reset-password">
          Forgot password?
        </Link>
      </div>
    </form>
  );
}
